module.exports = __webpack_public_path__ + "img/section3_6.6eb516af.png";